import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const SettingsMenu = () => {
	const profile = useSelector(state => state.user.profile);

	const roleRoutes = {
		'lab-manager': '/settings/lab-mgt',
		'cafeteria-audit': '/settings/food-items',
		'hr-pay-compensation': '/settings/qualification',
		'hr-manager': '/settings/qualification',
		'hr-officer': '/settings/qualification',
	};

	return (
		<>
			<li className="sub-header">
				<span>CONFIGURATIONS</span>
			</li>
			<li>
				<Link to={roleRoutes[profile.role.slug] || '/settings'}>
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Settings</span>
				</Link>
			</li>
		</>
	);
};

export default SettingsMenu;
